var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('hgroup',[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v(_vm._s(_vm.$t("not_exist")))]),_c('a',{attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$t("go_to_main")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }